export default __webpack_public_path__ + "static/media/srfb3.00e8e695.jpeg";